import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import APIService from '../APIService';
import { API_HOST, apiEndpoints } from '../../constants/APIConstants';

const getjobCatergory = options => {
  const jobCategories = options.jobCategories || [];
  let paramString = '';
  if (isEmpty(jobCategories)) {
    return paramString;
  }
  forEach(jobCategories, role => {
    paramString += `&jobCategories[]=${role}`;
  });
  return paramString;
};

const getLocalities = options => {
  const localities = options.localities || [];
  let paramString = '';
  if (isEmpty(localities)) {
    return paramString;
  }
  forEach(localities, role => {
    paramString += `&localities[]=${role}`;
  });
  return paramString;
};

// @todo move to job service once feedback and ratings comes in
export default {
  getJobsFeed(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else {
        APIService.request(
          {
            method: 'GET',
            url: `${API_HOST}${apiEndpoints.JOBS}?offset=${options.offset}&limit=${options.limit ||
              10}&city=${options.city && options.city.id}&minSalary=${
              options.minSalary
            }${getjobCatergory(options)}${getLocalities(options)}`,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
      }
    });
  },

  applyJob(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else
        APIService.request(
          {
            method: 'POST',
            url: `${API_HOST}${apiEndpoints.JOB_APPLICATION}`,
            isAuthenticated: true,
            includeTrackingProperties: true,
            data: options,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
    });
  },

  getJobsApplicationFeed() {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          method: 'GET',
          url: `${API_HOST}${apiEndpoints.JOB_APPLICATION}`,
          isAuthenticated: true,
        },
        (error, data) => {
          if (error) {
            reject(error);
          } else if (data) {
            resolve(data);
          } else {
            resolve(null);
          }
        }
      );
    });
  },

  getJobApplicationTracking(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else
        APIService.request(
          {
            method: 'GET',
            url: `${API_HOST}${apiEndpoints.JOB_APPLICATION}/${options.jobApplicationId}${apiEndpoints.TRACK}`,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
    });
  },
  getUserSettings() {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          method: 'GET',
          url: `${API_HOST}${apiEndpoints.USER_SETTINGS}`,
          isAuthenticated: true,
        },
        (error, data) => {
          if (error) {
            reject(error);
          } else if (data) {
            resolve(data);
          } else {
            resolve(null);
          }
        }
      );
    });
  },
  updateUserSettings(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else
        APIService.request(
          {
            method: 'PATCH',
            url: `${API_HOST}${apiEndpoints.USER_SETTINGS}`,
            data: options,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
    });
  },
  createUserJobCall(options) {
    return new Promise((resolve, reject) => {
      if (isEmpty(options)) reject(new Error('invalid params'));
      else
        APIService.request(
          {
            method: 'POST',
            url: `${API_HOST}${apiEndpoints.MITRA_CALL}`,
            data: options,
            isAuthenticated: true,
          },
          (error, data) => {
            if (error) {
              reject(error);
            } else if (data) {
              resolve(data);
            } else {
              resolve(null);
            }
          }
        );
    });
  },
};
